<template>
  <div
    class="tw:relative tw:w-full tw:rounded-full tw:bg-[var(--progress-bg)] tw:overflow-hidden"
    :style="{ height: props.height }">
    <div
      class="tw:bg-[var(--maincolor)] tw:transition-all tw:duration-300"
      :style="{ height: props.height, width: `${props.progress ?? 0}%` }"></div>
    <TextPlay
      v-if="props.showValue"
      class="tw:absolute tw:top-1/2 tw:left-1/2 tw:transform tw:-translate-x-1/2 tw:-translate-y-1/2"
      :text="`${props.progress ?? 0}%`" size="sm" color="var(--fontcolor)" weight="semibold" />
  </div>
</template>

<script setup lang="ts">
import TextPlay from '../TextPlay/TextPlay.vue'

const props = withDefaults(
  defineProps<{
    progress?: number
    height?: string
    max?: number
    showValue?: boolean
  }>(),
  {
    progress: 0,
    height: "14px",
    max: 100,
    showValue: false,
  }
)
</script>
